<template>
    <div class="landing-navbar-base">
        <div class="container">
            <div class="inner">
                <div class="nav-left">
                    <div class="site-brand">
                        <a href="/">
                            <img src="/favicon.ico" alt="H5mota">
                            <div class="logo">
                                <span class="h5mota">H5mota</span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="nav-right">
                    <div class="nav-menu">
                        <a href="/playNew.php"><span>玩塔</span></a>
                        <a href="/bbs/"><span>论坛</span></a>
                        <a href="/user/login.html"><span>登录</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { scrollToElm } from '../../utils/utils'

export default {
    methods: {
        to(id) {
            scrollToElm(document.getElementById(id));
        }
    }
}
</script>

<style lang="less">
.landing-navbar-base,
.landing-navbar-base * {
    -webkit-transition: 0.4s all;
    -o-transition: 0.4s all;
    transition: 0.4s all;
}
.landing-navbar-base {
    .container {
        top: 80px;
        padding-top: 20px;
    }
    .inner {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
            -ms-flex-pack: justify;
                justify-content: space-between;
        color: white;
        .nav-right {
            text-align: right;
        }
        .site-brand, .site-brand a {
            height: 40px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            img {
                height: 40px;
            }
            .logo {
                color: white;
                font-weight: 300;
                padding-left: 10px;
                font-size: 25px;
            }
        }
        .nav-menu {
            font-weight: 300;
            font-size: 15px;
            margin: 8px;
            a {
                text-decoration: none;
                color: inherit;
                &:not(:last-child) {
                    margin-right: 25px;
                }
            }
            span {
                padding: 8px 15px 10px 15px;
                cursor: pointer;
                border-radius: 1020px;
            }
            span {
                &:hover {
                    color: black;
                    background: white;
                    -webkit-box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
                            box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.15);
                }
            }
        }
    }
}
</style>